import { LoginHintExpirationTypeTypes } from "@enums/login-hint-expiration-type-types";
import { SelectOption } from "@idw-types/common";

export const LOGIN_HINT_EXPIRATION_TYPE_OPTIONS: Array<SelectOption<LoginHintExpirationTypeTypes>> = [
    { label: "Duration", value: LoginHintExpirationTypeTypes.DURATION },
    { label: "Date And Time (UTC)", value: LoginHintExpirationTypeTypes.DATE_AND_TIME }
];